import React from "react";

function bragCopy(latencyMs) {
  if (typeof latencyMs === "number" && latencyMs > 0 && latencyMs < 4000) {
    const secs = (latencyMs / 1000).toFixed(latencyMs < 1000 ? 1 : 0);
    return `Priced in ${secs}s - driver, fuel and your full route, no waiting for a callback.`;
  }
  return "Instant all-in pricing - driver, fuel and your route included, right here online.";
}

/**
 * Short celebratory strip after the AI assistant and before other vehicles.
 */
const QuoteSpeedBrag = ({ latencyMs = null }) => (
  <div className="lp2-quote-brag" role="status" aria-label="Quote delivered quickly">
    <div className="lp2-quote-brag-icon" aria-hidden="true">
      <i className="mdi mdi-lightning-bolt" />
    </div>
    <div className="lp2-quote-brag-text">
      <strong className="lp2-quote-brag-title">Wow, that was really qik!</strong>
      <span className="lp2-quote-brag-sub">{bragCopy(latencyMs)} Place a booking to experience the future of transportation.</span>
    </div>
  </div>
);

export default QuoteSpeedBrag;
